<template>
  <div class="add-message-push-page">
    <a-page-header style="border: 1px solid rgb(235, 237, 240)" :title="title"> </a-page-header>
    <div>
      <a-form-model
        :form="form"
        :label-col="{ span: 2 }"
        :wrapper-col="{ span: 10 }"
        :rules="rules"
        @submit="handleSubmit"
      >
        <div style="margin: 20px 50px 16px 50px">
          <a-collapse default-active-key="1" :bordered="false">
            <template #expandIcon="props">
              <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
            </template>
            <template v-for="(index, noSet) in setMap">
              <a-collapse-panel :key="index" :header="noSet" :style="customStyle">
                <div>类型码：</div>
                <template v-for="(setEntity, index2) in setMap[noSet]">
                  <!--                  {{index2}}:{{item}}-->
                  <div class="push-item" :key="index2">
                    <a-checkbox
                      :disabled="isEdit"
                      v-model="selectPushCheckBox[setEntity.key]"
                      @change="onChange(setEntity)"
                    >
                      {{ setEntity.key }} - {{ setEntity.value }}
                    </a-checkbox>
                  </div>
                </template>
              </a-collapse-panel>
            </template>
          </a-collapse>
        </div>
        <a-form-model-item label="最大重试次数" required>
          <a-input-number v-model="form.maxRetryCount" min="1" max="3"></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="推送地址" required>
          <div style="display: flex">
            <a-input
              placeholder="请用域名开头的地址，切勿直接使用IP"
              v-model="form.targetUrl"
            ></a-input>
            <a-button style="width: 200px; margin-left: 10px" @click="handleAddressCheck">
              <a-icon
                v-if="isSuccess === '1'"
                type="check-circle"
                theme="twoTone"
                two-tone-color="#52c41a"
              />
              <a-icon
                v-if="isSuccess === '2'"
                type="close-circle"
                theme="twoTone"
                two-tone-color="#FF0000"
              />
              地址检查
            </a-button>
            <div style="left: 10px; position: relative; bottom: 5px; width: 200px">
              <a
                href="https://dev.3vjia.com/document?apiId=48316ced48e9440f8f49669eebd5108a"
                target="_blank"
                >推送信息规范</a
              >
            </div>
          </div>
        </a-form-model-item>
        <div style="margin-top: 10px; margin-left: 30px">
          <div style="float: left; margin-right: 50px; width: 40%">
            <a-card>
              <p>发送例子</p>
              <MonacoEditor
                width="100%"
                height="300px"
                theme="vs-dark"
                :options="{
                  roundedSelection: true,
                  autoIndent: true ,
                }"
                language="javascript"
                :value="JSON.stringify(this.jsonExample, null, 4)"
                @change="onJsonChange"
              ></MonacoEditor>
            </a-card>
          </div>
          <div style="float: left; width: 40%">
            <a-card>
              <a-spin :spinning="spinning">
                <p v-if="showAddress">返回结果</p>
                <p v-else>正确的返回结果</p>
                <MonacoEditor
                  width="100%"
                  height="300px"
                  theme="vs-dark"
                  :options="{
                    readOnly: true,
                    roundedSelection: true,
                    autoIndent: true,
                  }"
                  language="javascript"
                  :value="JSON.stringify(this.sendResult, null, 4)"
                ></MonacoEditor>
              </a-spin>
            </a-card>
          </div>
        </div>
      </a-form-model>
    </div>
    <div class="add-message-push-footer">
      <a-button style="margin-top: 23px" type="primary" @click="handleSubmit">提交</a-button>
      <a-button style="margin-top: 23px; margin-left: 20px" @click="back">取消</a-button>
    </div>
  </div>
</template>

<script>
import {
  devAddMessagePush,
  devEditMessagePush,
  devPostMessage,
} from '@/services/modules/my-config';
import MonacoEditor from 'monaco-editor-vue';
import debounce from 'lodash/debounce';

export default {
  name: 'AddMessagePush',
  props: ['title', 'setMap', 'editItem', 'env'],
  components: {
    MonacoEditor,
  },
  data() {
    function dateToString(date) {
      const y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? `0${m}` : m;
      let d = date.getDate();
      d = d < 10 ? `0${d}` : d;
      let h = date.getHours();
      h = h < 10 ? `0${h}` : h;
      let minute = date.getMinutes();
      minute = minute < 10 ? `0${minute}` : minute;
      let second = date.getSeconds();
      second = second < 10 ? `0${second}` : second;
      return `${y}-${m}-${d} ${h}:${minute}:${second}`;
    }

    return {
      editList: [],
      isEdit: false,
      spinning: false,
      customStyle: 'background: #ffffff',
      form: {
        targetUrl: '',
        maxRetryCount: 1,
      },
      rules: {
        isOpen: { required: true, message: '', trigger: 'blur' },
      },
      showAddress: false,
      selectPush: {},
      selectPushCheckBox: {},
      isSuccess: '0',
      jsonExample: {
        operateType: 'CREATE_ORDER',
        operateUser: {
          userId: '1000123456',
          outUserId: '123456',
          userName: '3vj13800000000',
          name: '小蔡',
          nickName: '小蔡',
          mobile: '13800000000',
          avatar:
            'https://img3.admin.3vjia.com/UpFile/C00005842/ADMIN/UserSetting/202005/1001266879/89faef49527140eb883d7a5190c0048a.jpg',
        },
        operateTime: dateToString(new Date()),
        subjectId: 'F053521B72F34613BEAD2CC8B6279E75',
      },
      sendResult: {
        code: 10000,
        message: '保存成功',
      },
    };
  },
  mounted() {
    // eslint-disable-next-line no-empty
    if (this.title === '新增配置') {
    } else if (this.title === '修改配置') {
      this.isEdit = true;
      console.log(this.setMap);
      console.log(this.selectPush);
      console.log(this.selectPushCheckBox);
      this.form.maxRetryCount = this.editItem.maxRetryCount;
      this.form.targetUrl = this.editItem.targetUrl;
      // eslint-disable-next-line no-restricted-syntax,guard-for-in
      for (const key in this.setMap) {
        this.setMap[key].forEach((value) => {
          this.selectPush[value.key] = value;
          this.selectPushCheckBox[value.key] = true;
        });
        this.editList = this.editItem.editList;
      }
    }
  },
  methods: {
    onChange(entity) {
      if (this.selectPush[entity.key]) {
        delete this.selectPush[entity.key];
      } else {
        this.selectPush[entity.key] = entity;
      }
      console.log(this.selectPush);
    },
    handleSubmit() {
      const { length } = Object.keys(this.selectPush);
      if (!this.form.targetUrl) {
        this.$message.error('请填写推送地址后提交');
        return;
      }
      if (length === 0) {
        this.$message.error('请选择需要推送的类型');
        return;
      }
      const taskTypeList = [];
      // eslint-disable-next-line guard-for-in,no-restricted-syntax
      for (const key in this.selectPush) {
        console.log(this.selectPush[key]);
        taskTypeList.push(this.selectPush[key].key);
      }
      const data = {
        taskTypeList,
        targetUrl: this.form.targetUrl,
        maxRetryCount: this.form.maxRetryCount,
        env: this.env,
      };
      if (!this.isEdit) {
        devAddMessagePush(data).then((res) => {
          if (res.success) {
            this.$message.success('新增成功');
            this.$emit('backList');
          } else {
            this.$message.error(res.errorMessage);
          }
        });
      } else {
        data.editList = this.editList;
        devEditMessagePush(data).then((res) => {
          if (res.success) {
            this.$message.success('修改成功');
            this.$emit('backList');
          } else {
            this.$message.error(res.errorMessage);
          }
        });
      }
    },
    back() {
      this.$emit('backList');
    },
    handleAddressCheck() {
      if (this.form.targetUrl !== '') {
        if (this.isValidIP(this.form.targetUrl)) {
          this.$message.error('请使用域名作为请求地址');
          return;
        }
        this.showAddress = true;
        this.sendResult = '';
        const data = {
          targetUrl: this.form.targetUrl,
          jsonExample: this.jsonExample,
        };
        this.spinning = true;
        devPostMessage(data).then((res) => {
          if (res.success) {
            const { result } = res;
            this.sendResult = result.sendResult;
            if (`${this.sendResult.code}` === '10000') {
              this.isSuccess = '1';
            } else {
              this.isSuccess = '2';
              this.$message.error('提交失败！请先按照三维规范配置完成推送接口地址');
            }
          } else {
            this.$message.error('提交失败！请先按照三维规范配置完成推送接口地址');
            this.isSuccess = '2';
            this.sendResult = res.errorMessage;
          }
          this.spinning = false;
        });
      } else {
        this.$message.error('请输入推送地址');
      }
    },
    isValidIP(ip) {
      const reg = /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/;
      return reg.exec(ip);
    },
    jsonErroTtip: debounce(function () {
      if (this.isJsonSyntaxError) {
        this.$message.error('发送例子的JSON格式不合法，请检查');
      }
    }, 1000),
    onJsonChange(value) {
      try {
        this.jsonExample = JSON.parse(value);
        if (this.isJsonSyntaxError) {
          this.$message.success('发送例子的JSON格式正确');
          this.isJsonSyntaxError = false;
        }
      } catch (e) {
        this.isJsonSyntaxError = true;
        this.jsonErroTtip();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.push-item {
  width: 50%;
  display: inline-flex;
  padding-top: 5px;
}
.add-message-push-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  background: #ffffff;
  .un-developer-page {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    background: white;
    -webkit-align-items: center;
    align-items: center;
    -webkit-justify-content: center;
    justify-content: center;
    border: 1px solid #ccc;
    .content {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 20px;
    }
    .child-div {
      text-align: center;
      align-items: center;
    }
  }
}
.add-message-push-footer {
  height: 90px;
  text-align: center;
}
</style>
